import { inputStepper } from "constants/formConstants";
import { useField } from "formik";
import React, { useEffect, useState } from "react";
import { Form, Label, Loader } from "semantic-ui-react";
import http from "utilities/http";

function QuantityInput({ forSale }) {
	const [
		{ value: quantity },
		{ error: quantityValidationError, touched },
		{ setValue: setQuantity },
	] = useField("quantity");
	const [{ value: productId }] = useField("productId");
	const [stockQuantity, setStockQuantity] = useState(0);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		if (forSale && productId) {
			setLoading(true);
			http({
				method: "GET",
				url: "/stock/byProduct/" + productId,
			})
				.then((response) => {
					const { stockQuantity: quantityInStock } = response.data;
					setStockQuantity(quantityInStock);
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(() => setLoading(false));
		}
	}, [productId, forSale]);
	return (
		<>
			<Form.Input
				name="quantity"
				placeholder={`Quantity ${forSale ? "sold" : ""}`}
				label="Quantity"
				value={quantity}
				onChange={(e) => setQuantity(e.target.value, true)}
				type="number"
				step={inputStepper}
				fluid
				labelPosition={forSale && "right"}
				min={0}
				error={forSale && quantity > stockQuantity}
			>
				<input />
				{forSale ? (
					<Label>
						{loading ? (
							<Loader active indeterminate size="tiny" />
						) : productId ? (
							`/ ${stockQuantity} units`
						) : (
							"0"
						)}
					</Label>
				) : null}
			</Form.Input>
			<p style={{ color: "red" }}>
				{quantityValidationError && touched && quantityValidationError}
			</p>
		</>
	);
}

export default QuantityInput;
